import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { ContentLayout } from '../ContentLayout';
import * as styles from './AccountSelectError.css';
export var AccountSelectError = function AccountSelectError(_ref) {
  var onRetry = _ref.onRetry,
      onChangeAccount = _ref.onChangeAccount;
  return /*#__PURE__*/React.createElement(ContentLayout, null, /*#__PURE__*/React.createElement("div", {
    className: styles['buttons']
  }, /*#__PURE__*/React.createElement(Button, {
    "data-name": "RetryByPhoneBtn",
    theme: "fill_primary",
    fullWidth: true,
    onClick: onRetry
  }, "\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0435\u0449\u0435 \u0440\u0430\u0437"), /*#__PURE__*/React.createElement(Button, {
    "data-name": "BackToAccountSelectBtn",
    theme: "fill_secondary",
    fullWidth: true,
    onClick: onChangeAccount
  }, "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0434\u0440\u0443\u0433\u043E\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442")));
};